import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { EventModalComponent } from '../../../features/vibration-events/components/event-modal/event-modal.component';
import { EventData } from '../../../features/vibration-events/models/event-data';
import { EventService } from '../../../features/vibration-events/services/event-service';
import { ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component';
import { RecordDetailComponent } from '../../components/record-detail/record-detail.component';
import { RecordModalComponent } from '../../components/record-modal/record-modal.component';
import { VibrationsChart } from '../../models/charts/VibrationsChart';
import { Site } from '../../models/site';
import { SitesHttpService } from '../../services/http/sites-http.service';
import { VibrationsRecordService } from '../../services/records/vibrations-record.service';
import { FonctionsService } from '../../services/utilities/fonctions.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EventPosition } from '../../../features/vibration-events/models/event-position';

import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { EventDetailComponent } from '../../../features/vibration-events/components/event-detail/event-detail.component';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ControlPointsService } from '../../../features/control-points/services/control-points-service';
import { ControlPoint } from '../../models/controlPoint';
import { ControlPointDetailComponent } from '../../../features/control-points/components/control-point-detail/control-point-detail.component';
import { SeismographDevice } from '../../../features/seismograph-devices/models/seismograph-device';
import { SeismographService } from '../../../features/seismograph-devices/services/seismograph-service';
import { Seismograph } from '../../models/seismograph';
import { DeviceDetailComponent } from '../../../features/seismograph-devices/components/device-detail/device-detail.component';
import { FormsModule, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { TriggerThresholdComponent } from '@shared/components/trigger-threshold/trigger-threshold.component';
import { DeviceConfigComponent } from '@shared/components/device-config/device-config.component';
import { AssignRecordsModalComponent } from '@shared/components/assign-records-modal/assign-records-modal.component';
import { AlarmConfigurationComponent } from '@shared/components/alarm-configuration/alarm-configuration.component';
import { Country } from '@shared/models/country';
import { SitesAreaService } from '@features/settings/sites-area/services/sites-area.service';
import { PonderationService } from '@shared/services/ponderation/ponderation.service';
import { LocalStorageService } from '@shared/services/utilities/local-storage.service';
import { DeviceConfigService } from '@shared/services/config/device-config.service';
import { WorkingStatusEnum } from '@shared/models/working-status-enum';
import { CurrentStateService } from 'app/core/services/current-state.service';
import { firstValueFrom } from 'rxjs';


@Component({
  selector: 'app-vibration-detail',
  imports: [
    AngularSvgIconModule,
    CommonModule,
    RecordDetailComponent,
    MatIconModule,
    EventDetailComponent,
    ControlPointDetailComponent,
    DeviceDetailComponent,
    FormsModule,
    TranslateModule,
    TriggerThresholdComponent,
    DeviceConfigComponent,
    AlarmConfigurationComponent
  ],

  templateUrl: './vibration-detail.page.html',
  styleUrl: './vibration-detail.page.scss'
})
export class VibrationDetailpage implements OnInit {
  event: EventData;
  controlPoint: ControlPoint;
  siteId!: number;
  eventId!: number;
  vibrationRecords: VibrationsChart[];
  filteredRecords: VibrationsChart[] = [];
  isDetailsVisible: boolean[] = [];
  events: EventData[] = [];
  site: Site;
  modaleOpend = false;
  cordX: number;
  cordY: number;
  cordZ: number;
  transformedPsition: EventPosition;
  selectedOption: string = 'all';
  controlPointId: number;
  numeroContolPoint: number;
  deviceSerialNumber: string;
  device: Seismograph;
  showReport = false;
  showNewRecord = true;
  recordId: number | null = null;
  tab: number = 1;
  protected countries: Country[] | undefined;
  ponderations: any[] = [];
  deviceConfigForm: FormGroup;
  initialDeviceConfigValue: any;
  isDeviceConfigChanged = false;
  filterDate: string | null = null;
  startDate: string | null = null;
  endDate: string | null = null;
  private pendingRecordNavigationId: number | null = null;
  private isAutoNavigatingToRecord = false;

  constructor(
    private fb: FormBuilder,
    private vibrationsRecordService: VibrationsRecordService,
    private route: ActivatedRoute,
    private eventService: EventService,
    private siteServcie: SitesHttpService,
    private router: Router,
    private dialogRecorde: MatDialog,
    public dialogConfirme: MatDialog,
    private fonctionsService: FonctionsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private controlPointsService: ControlPointsService,
    private seismographService: SeismographService,
    private sitesAreaService: SitesAreaService,
    private ponderationService: PonderationService,
    private localStorageService: LocalStorageService,
    private deviceConfigService: DeviceConfigService,
    private currentStateService: CurrentStateService
  ) {
  }

  ngOnInit(): void {
    this.loadCountries();
    this.route.queryParams.subscribe(params => {
      const parsedRecordId = Number(params['recordId']);
      this.recordId = Number.isFinite(parsedRecordId) && parsedRecordId > 0 ? parsedRecordId : null;
      this.pendingRecordNavigationId = this.recordId;
      this.eventId = +params['eventId'];
      this.siteId = +params['siteId'];
      this.controlPointId = +params['controlPointId'];
      this.deviceSerialNumber = params['deviceId'];
      this.showReport = !isNaN(this.eventId);
      const dateParam = params['date'];
      if (dateParam) {
        this.filterDate = dateParam;
        this.startDate = `${dateParam}T00:00:00`;
        this.endDate = `${dateParam}T23:59:59`;
      }
      this.loadSite();
      this.site = (this.localStorageService.getItem('allSites') as Site[])?.find(s => s.siteId == this.siteId);
    });


    this.loadEvents();
    if (this.eventId) {
      this.loadCurrentEvent()
    }

    if (this.controlPointId) {
      this.loadControlPoint()
    }
    if (this.deviceSerialNumber) {
      this.loadSeismographDevice();
      this.initDeviceConfigForm();
      this.loadDeviceConfiguration();
    }

    this.loadVibrationRecords();
    this.loadPonderations();
    
  }
  loadPonderations(){
    this.ponderationService.getAllPonderations().subscribe({
     next: (response) => {
     this.ponderations = response.data;
      }
     });
  }

  async loadSeismographDevice() {
    this.device = await this.seismographService.getSeismographBySerialNumber(this.deviceSerialNumber);
  }

  loadControlPoint() {
    this.controlPointsService.getControlPointsBySiteId(this.siteId, false).subscribe({
      next: (response) => {
        this.controlPoint = response.find(cp => cp.controlPointId === this.controlPointId);
        this.numeroContolPoint = response.indexOf(this.controlPoint) + 1;
      },
      error: (err) => {
        console.error('Error loading control point', err);
      }
    });
  }
  
  loadEvents(): void {
    this.eventService.getVibrationEvents(this.siteId, this.controlPointId).subscribe((response) => {
      this.events = response.data;
    });
  }

  onDateFilterChange(date: string | null): void {
    this.filterDate = date;
    if (date) {
      this.startDate = `${date}T00:00:00`;
      this.endDate = `${date}T23:59:59`;
    } else {
      this.startDate = null;
      this.endDate = null;
    }
    this.currentPage = 1;
    this.loadVibrationRecords();
  }

  loadVibrationRecords(): void {
    this.vibrationsRecordService.GetRecords(this.siteId, this.eventId,null, this.controlPointId, this.deviceSerialNumber, this.currentPage, this.pageSize, false,false,false, null, null, this.startDate, this.endDate)
      .subscribe({
        next: (response) => {
          this.vibrationRecords = response.data.records;
          this.totalRecords = response.data.total;
          this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
          this.updateVisiblePages();

          this.filterRecords(this.vibrationRecords,'all');
          this.tryNavigateToPendingRecord();

        },
        error: (err) => {
          console.error('Error loading vibration records', err);
        }
      });
  }

  private async tryNavigateToPendingRecord(): Promise<void> {
    if (!this.pendingRecordNavigationId || this.isAutoNavigatingToRecord) {
      return;
    }

    const targetRecordId = this.pendingRecordNavigationId;
    const isInCurrentPage = this.vibrationRecords?.some(record => record.id === targetRecordId);

    if (isInCurrentPage) {
      this.recordId = targetRecordId;
      this.pendingRecordNavigationId = null;
      return;
    }

    if (!this.totalPages || this.totalPages <= 1) {
      this.pendingRecordNavigationId = null;
      return;
    }

    this.isAutoNavigatingToRecord = true;
    try {
      for (let page = 1; page <= this.totalPages; page++) {
        if (page === this.currentPage) {
          continue;
        }

        const response = await firstValueFrom(
          this.vibrationsRecordService.GetRecords(
            this.siteId,
            this.eventId,
            null,
            this.controlPointId,
            this.deviceSerialNumber,
            page,
            this.pageSize,
            false,
            false,
            false,
            null,
            null,
            this.startDate,
            this.endDate
          )
        );

        const records = response?.data?.records || [];
        if (records.some(record => record.id === targetRecordId)) {
          this.currentPage = page;
          this.recordId = targetRecordId;
          this.pendingRecordNavigationId = null;
          this.updateVisiblePages();
          this.loadVibrationRecords();
          return;
        }
      }

      this.pendingRecordNavigationId = null;
    } catch (error) {
      console.error('Error searching target record page', error);
      this.pendingRecordNavigationId = null;
    } finally {
      this.isAutoNavigatingToRecord = false;
    }
  }

  loadCurrentEvent(): void {
    this.eventService.getVibrationEvent(this.siteId, this.eventId).subscribe({
      next: (response) => {
        this.event = response.data;

      },
      error: (err) => {
        console.error('Error loading source detail', err);
      }
    });
  }

  loadSite(): void {
    this.siteServcie.getSitesAcitve().subscribe((site) => {
      this.site = site.find(s => s.siteId == this.siteId);
    })

  }
  loadCountries(): void {
   this.sitesAreaService.getCountries().subscribe(countries => {
     this.countries = countries;
   });
  }

  backToEventList(): void {
    this.router.navigate(['/'], { queryParams: { eventId: this.eventId, siteId: this.siteId } });
  }

  onRecordClick(): void {
    if(this.site == null || this.site == undefined){
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false; // Désactiver le focus automatique
    console.log(this.controlPoint);
    
    dialogConfig.data = {
      siteId: this.siteId,
      eventId: this.eventId,
      controlPointId: this.controlPointId,
      siteName: this.site.nom,
      controlPointName: this.controlPoint?.name,
      regionName: this.site.region?.nom
    };
    dialogConfig.enterAnimationDuration = '0ms';
  
    const dialogRef = this.dialogRecorde.open(RecordModalComponent, dialogConfig);
    
    this.modaleOpend = true;
    
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.isDetailsVisible = [];
        this.loadVibrationRecords();
      }
    
      this.modaleOpend = false;
    });
  }

  assignMultiRecords() {
         const dialogConfig = new MatDialogConfig();
          dialogConfig.autoFocus = false;
          dialogConfig.data = {
            siteId: this.siteId,
            eventId: this.eventId,
            controlPointId: this.controlPointId,
            events: this.events,
          }
          dialogConfig.enterAnimationDuration = '0ms';
          const dialogRef = this.dialogRecorde.open(AssignRecordsModalComponent, dialogConfig);
          this.modaleOpend = true;
          dialogRef.afterClosed().subscribe((result) => {
            if(result == true) {
              this.loadVibrationRecords();
            }
            this.modaleOpend = false;
          });
  }

  deleteVibrationEvent() {
    this.eventService.deleteVibrationEvent(this.siteId, this.eventId).subscribe({
      next: (response) => {
        this.router.navigate(['/'], { queryParams: { eventId: this.eventId, siteId: this.siteId } });
        this.fonctionsService.launch_toast(true, 'Source successfully deleted');
      },
      error: (err) => {
        this.fonctionsService.launch_toast(false, 'Error deleting source');
      }
    })
  }

  public onDelete(): void {
    this.modaleOpend = true;

    const dialogRef = this.dialogConfirme.open(ConfirmDialogComponent, {
      data: {
        title: 'You want to delete this source?',
        message: 'Are you sure you want to delete this source?'
      },
      enterAnimationDuration: '0ms',
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      this.modaleOpend = false;
      if (result) {
        this.deleteVibrationEvent();
      }
    });
  }


  filterRecords(records: VibrationsChart[],option: string): VibrationsChart[] {
    this.selectedOption = option;
    if (this.selectedOption === 'assigned') {
      this.filteredRecords = this.vibrationRecords.filter(record => record.controlPointId != null && record.eventId != null);
    } else if (this.selectedOption === 'unAssigned') {
      this.filteredRecords = this.vibrationRecords.filter(record => record.controlPointId == null || record.eventId == null);
    } else if (this.selectedOption === 'all') {

      if (this.deviceSerialNumber) {
        this.vibrationRecords = this.vibrationRecords.filter(record => record.recordMetadata.seismographSerialNumber === this.deviceSerialNumber);
      }

      this.filteredRecords = [...this.vibrationRecords];
    }
    return this.filteredRecords;
  }

  changerTab(numTab: number) {
    if (numTab == 1) {
      this.tab = 1;
    } else if (numTab == 2) {
      this.tab = 2;
    }
    else
      this.tab = numTab;
  }

  currentPage: number = 1;
  pageSize: number = 30;
  totalRecords: number = 0;
  totalPages: number = 0;
  pages: number[] = [];

  updateVisiblePages(): void {
    const maxVisiblePages = 5;
    
    if (this.totalPages <= maxVisiblePages) {
      // Si le total de pages est <= 5, afficher toutes les pages
      this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
    } else {
      // Sinon, afficher au maximum 5 pages autour de la page courante
      let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);
      
      // Ajuster le début si on est proche de la fin
      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }
      
      this.pages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    }
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages) return;

    this.currentPage = page;
    this.updateVisiblePages();
    this.loadVibrationRecords();
  }

  onDeviceConfigFormReady(form: FormGroup) {
    this.deviceConfigForm = form;
  }

  initDeviceConfigForm() {
    this.deviceConfigForm = this.fb.group({
      id: [null],
      deviceSerial: [this.deviceSerialNumber],
      receivedDate: [new Date()],
      recTime: [1, [Validators.required, Validators.min(1), Validators.max(32)]],
      recMode: [WorkingStatusEnum.NO_REC, Validators.required],
      preTrg: [0, [Validators.required, Validators.min(0), Validators.max(500)]],
      trgVib: [0.1, [Validators.required, Validators.min(0.1), Validators.max(200)]],
      trgSnd: [94, [Validators.required, Validators.min(100), Validators.max(140)]],
      tmrUse: [false],
      tmrStartTime: ['00:00'],
      tmrEndTime: ['23:59'],
      activeDays: [0, [Validators.min(0)]],
      uploadInterval: [0, [Validators.min(0), Validators.max(60)]],
      realTUse: [false],
      trgUseVib: [true],
      trgUseSnd: [true],
      redAlertValue: [null],
      yellowAlertValue: [null],
      orangeAlertValue: [null],
      emailsThreshold: this.fb.array([])
    });
    this.initialDeviceConfigValue = this.deviceConfigForm.getRawValue();
    this.deviceConfigForm.valueChanges.subscribe(() => {
      this.isDeviceConfigChanged = JSON.stringify(this.deviceConfigForm.value) !== JSON.stringify(this.initialDeviceConfigValue);
    });
  }

  async loadDeviceConfiguration() {
    if (!this.deviceSerialNumber) {
      return;
    }
    try {
      this.currentStateService.setShowLoading(true);
      const deviceConfig = await this.deviceConfigService.getDeviceConfiguration(this.deviceSerialNumber, null).toPromise();
      
      if (deviceConfig) {
        const startTime = deviceConfig.tmrStartTime ? this.formatTimeForInput(deviceConfig.tmrStartTime) : '00:00';
        const endTime = deviceConfig.tmrEndTime ? this.formatTimeForInput(deviceConfig.tmrEndTime) : '23:59';
        const { emailsThreshold, ...rest } = deviceConfig;
        this.deviceConfigForm.patchValue({
          ...rest,
          trgSnd: rest.trgSnd != null ? parseFloat((20 * Math.log10(rest.trgSnd / 20e-6)).toFixed(1)) : 94,
          tmrStartTime: startTime,
          tmrEndTime: endTime
        });
        const emailsArray = this.deviceConfigForm.get('emailsThreshold') as any;
        emailsArray.clear();
        (emailsThreshold || []).forEach((email: any) => {
          emailsArray.push(this.fb.group({
            id: [email.id],
            thresholdId: [email.thresholdId],
            email: [email.email],
            isActive: [email.isActive],
            alarm: [email.alarm],
            configId: [email.configId]
          }));
        });
        this.initialDeviceConfigValue = this.deviceConfigForm.getRawValue();
      }
    } catch (error) {
      // ...error handling...
    } finally {
      this.currentStateService.setShowLoading(false);
    }
  }

  private formatTimeForInput(timeString: string): string {
    if (!timeString) return '00:00';
    if (timeString.match(/^\d{2}:\d{2}$/)) {
      return timeString;
    }
    const time = new Date(`1970-01-01T${timeString}`);
    if (!isNaN(time.getTime())) {
      return time.toTimeString().substring(0, 5);
    }
    return '00:00';
  }
}
